import React, { createContext } from 'react'

import defaultSettings from './defaultSettings'
import { TOrderEntrySettings } from './types'

export const OrderEntryContext =
  createContext<TOrderEntrySettings>(defaultSettings)

export type TProps = {
  value: TOrderEntrySettings
  key: string
  children: React.ReactElement
}

export const OrderEntryContextProvider = (
  props: TProps,
): React.ReactElement => <OrderEntryContext.Provider {...props} />

export default OrderEntryContext
